module.exports = __webpack_public_path__ + "img/information.e9874616.svg";